import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Checkbox } from "./ui/checkbox";

const KEY = "mueller_zeitlofs_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [stats, setStats] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const save = (value) => {
    localStorage.setItem(KEY, JSON.stringify(value));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed bottom-0 left-0 right-0 z-[90] bg-white shadow-[0_-8px_30px_rgba(0,0,0,0.12)]"
          style={{ borderTop: "2px solid #2A5C2A" }}
          initial={{ y: 120 }} animate={{ y: 0 }} exit={{ y: 140 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
          data-testid="cookie-banner"
        >
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5">
            <p className="text-sm text-[#2A2A2A]">
              Wir verwenden Cookies, um unsere Website optimal für Sie zu gestalten. Notwendige Cookies sind
              für den Betrieb erforderlich. Weitere Informationen finden Sie in unserer{" "}
              <a href="/datenschutz" className="text-[#2A5C2A] underline">Datenschutzerklärung</a>.
            </p>
            {showSettings && (
              <div className="mt-4 flex flex-col gap-2 rounded-md bg-[#F8F7F4] p-4" data-testid="cookie-settings-panel">
                <label className="flex items-center gap-3 text-sm">
                  <Checkbox checked disabled className="data-[state=checked]:bg-[#2A5C2A] data-[state=checked]:border-[#2A5C2A]" />
                  Notwendige Cookies (immer aktiv)
                </label>
                <label className="flex items-center gap-3 text-sm cursor-pointer">
                  <Checkbox checked={stats} onCheckedChange={setStats} className="data-[state=checked]:bg-[#2A5C2A] data-[state=checked]:border-[#2A5C2A]" data-testid="cookie-stats-checkbox" />
                  Statistik-Cookies
                </label>
              </div>
            )}
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <button
                onClick={() => save({ necessary: true, statistics: true })}
                className="btn-green rounded-full px-6 py-2.5 text-sm font-semibold border border-[#2A5C2A]"
                data-testid="cookie-accept-all"
              >
                Alle akzeptieren
              </button>
              <button
                onClick={() => save({ necessary: true, statistics: showSettings ? stats : false })}
                className="rounded-full px-6 py-2.5 text-sm font-semibold border border-[#DDD9D0] text-[#2A2A2A] hover:border-[#2A5C2A] hover:text-[#2A5C2A] transition-colors"
                data-testid="cookie-necessary-only"
              >
                {showSettings ? "Auswahl speichern" : "Nur notwendige"}
              </button>
              <button
                onClick={() => setShowSettings(!showSettings)}
                className="text-sm text-[#666666] underline hover:text-[#2A5C2A] transition-colors"
                data-testid="cookie-settings-toggle"
              >
                Einstellungen
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
